var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowUpDateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FEEDEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4537 12.3281V15.7466M18.6168 12.3281V15.7466M29.7267 20.8742C29.7267 17.6515 29.7267 16.0397 28.7251 15.0389C27.7235 14.0382 26.1126 14.0373 22.8898 14.0373H21.1806C17.9579 14.0373 16.3461 14.0373 15.3454 15.0389C14.3446 16.0405 14.3438 17.6515 14.3438 20.8742V22.5834C14.3438 25.8062 14.3437 27.418 15.3454 28.4187C16.347 29.4195 17.9579 29.4203 21.1806 29.4203M14.3438 19.165H29.7267",
    stroke: "#F04438",
    strokeWidth: 1.39845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1642 22.5607V21.3359M27.1642 22.5607C27.8815 22.5885 28.5598 22.8941 29.0559 23.4129C29.5519 23.9317 29.8268 24.623 29.8225 25.3407V26.2729C29.8225 27.5086 30.7894 27.8172 30.7894 28.4351C30.7894 28.7422 30.7894 29.1042 30.5108 29.1042H23.8177C23.5391 29.1042 23.5391 28.7422 23.5391 28.4351C23.5391 27.8172 24.5059 27.5086 24.5059 26.2729V25.3407C24.5016 24.623 24.7766 23.9317 25.2726 23.4129C25.7687 22.8941 26.447 22.5885 27.1642 22.5607ZM25.4723 29.1042C25.521 29.5454 25.6308 29.9017 25.9612 30.1979C26.2918 30.4943 26.7202 30.6583 27.1642 30.6583C27.6083 30.6583 28.0367 30.4943 28.3673 30.1979C28.6977 29.9017 29.0074 29.5454 29.0561 29.1042H25.4723Z",
    stroke: "#F04438",
    strokeWidth: 1.12993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpDateIcon);
export default __webpack_public_path__ + "static/media/FollowUp-Date-icon.6e8fd9f20413a524460fdfde13a21b75.svg";
export { ForwardRef as ReactComponent };